module.exports = __webpack_public_path__ + "img/maas_wrapbg13.d3ddd62b.png";